import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-success-modal',
    templateUrl: './success-modal.component.html',
    styleUrl: './success-modal.component.scss',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SuccessModalComponent {
  @Input() message = '';

  @Output() readonly visibleChange = new EventEmitter<boolean>();

  private _visible = false;
  @Input() 
  get visible(): boolean {
    return this._visible;
  };
  set visible(value: boolean) {
    if (value === this._visible) return;
    this._visible = value;

    this.visibleChange.emit(value);
  }
}
